/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CharityContainer_user$ref: FragmentReference;
export type CharityContainer_user = {|
  +id: string,
  +vcCurrent: ?number,
  +$fragmentRefs: DonateHeartsControlsContainer_user$ref,
  +$refType: CharityContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "CharityContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcCurrent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DonateHeartsControlsContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6a9d647a3f197b6856d98bbc6c583b76';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Donate/__generated__/CharityContainer_user.graphql.js